export const initState = {
    selectedProduct: null,
    currentRouteId: null,
    configurableInProgress: {},
    configurablePlanAcceptanceList: {},
    configurableModifiedList: {},
    deletedConfigurables: {},
    addedConfigurables: {}
}

const selectedObjects = (state = initState, action) => {
    switch (action.type) {
        case 'PRODUCT_CLICK':
        case 'SET_LAST_SELECTED_PRODUCT':
            return {...state, selectedProduct: action.product}
        case 'SET_LAST_ROUTE_ID':
            return {...state, currentRouteId: action.routeId}
        case 'ADD_CONFIGURABLE_IN_PROGRESS':
            return {
                ...state,
                configurableInProgress: {
                    ...state.configurableInProgress,
                    [action.refcode]: action.configData
                }
            }
        case 'ADD_CONFIGURABLE_PLAN_ACCEPTANCE_CHECKED':
            return {
                ...state,
                configurablePlanAcceptanceList: {
                    ...state.configurablePlanAcceptanceList,
                    [action.refcode]: {
                        isPlanAcceptanceChecked: action.isPlanAcceptanceChecked
                    }
                }
            }
        case 'ADD_CONFIGURABLE_MODIFIED_LIST':
            return {
                ...state,
                configurableModifiedList: {
                    ...state.configurableModifiedList,
                    [action.refcode]: {
                        isConfigurableModified: action.isConfigurableModified
                    }
                }
            }
        case 'ADD_DELETED_CONFIGURABLE_LIST':
            return {
                ...state,
                deletedConfigurables: {
                    ...state.deletedConfigurables,
                    [action.refcode]: true
                }
            }
        case 'ADD_ADDED_CONFIGURABLE_LIST':
            return {
                ...state,
                addedConfigurables: {
                    ...state.addedConfigurables,
                    [action.refcode]: true
                }
            }
        case 'RESET_ADDED_DELETED_CONFIGURABLE_LIST':
            return {
                ...state,
                deletedConfigurables: {},
                addedConfigurables: {}
            }
        default:
            return state
    }
}

export const getLastSelectedProduct = state => state.selectedObjects.selectedProduct

export const getLastRouteId = state => state.selectedObjects.currentRouteId

export const getConfigurablePlanAcceptanceList = state => state.selectedObjects.configurablePlanAcceptanceList

export const getConfigurableInProgress = state => state.selectedObjects.configurableInProgress

export const getConfigurableModifiedList = state => state.selectedObjects.configurableModifiedList

export const getDeletedConfigurables = state => state.selectedObjects.deletedConfigurables

export const getAddedConfigurables = state => state.selectedObjects.addedConfigurables


export default selectedObjects